import React, { useContext, useCallback } from 'react';
import { AjaxContext, AppContext, formatListData } from 'commons-ui';
import { AxiosResponse } from 'axios';
import { ISegmentOffer } from './type';
import { ACTIVATE_OFFER_URI, CREATE_OFFER_URI, DISABLE_OFFER_URI, GET_OFFER_URI, UPDATE_OFFER_URI } from '../../tdsHelper';

const useService = () => {
	const [segmentLabelList, setSegments] = React.useState<{ id: number; label: string }[]>([{ id: 0, label: 'HELLO' }]);
	const [mapValueList, setMapValues] = React.useState<Object>({});
	const { postData } = useContext(AjaxContext);
	const { app } = useContext(AppContext);

	const getTDSOfferData = useCallback(async (pageDetails: any, sortDetails: any, filterDetails: any) => {
		const response: AxiosResponse<{ success?: boolean }> = await postData({
			endpoint: GET_OFFER_URI,
			body: {
				page: pageDetails?.pageDetails,
				filters: filterDetails,
				sortInfoArray: sortDetails,
				isGold: true
			},
			queryParams: {
				appName: app.appName
			}
		});
		const listData = formatListData({ ...response?.data?.data?.tdsAbsorptionOffers });
		for (let idx = 0; idx < listData.length; idx += 1) listData[idx].index = idx + 1;
		const segmentExp = response?.data?.data?.segmentExp;
		const segmentList: { id: string; label: string }[] = [];
		const mapValues: {
			segmentExp: { [key: string]: { expName: string } };
		} = {
			segmentExp: response?.data?.data?.segmentExp
		};
		segmentExp.forEach((segment: string) => segmentList.push({ id: segment, label: segment }));
		setSegments(segmentList);
		setMapValues(mapValues);
		const count = response?.data?.data?.tdsAbsorptionOffers?.length;
		return { rowCount: count, data: listData };
	}, []);

	const requestCreateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: CREATE_OFFER_URI,
			body: { tdsAbsorptionOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestActivateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: ACTIVATE_OFFER_URI,
			body: { tdsAbsorptionOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: UPDATE_OFFER_URI,
			body: { tdsAbsorptionOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDisableOffer = useCallback((appName: string, data: ISegmentOffer) => {
		return postData({
			endpoint: DISABLE_OFFER_URI,
			body: { tdsAbsorptionOffers: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const toggleIsDisabledField = useCallback(
		async (rowData: ISegmentOffer, history: any, user: any, appData: any, showAlert: any) => {
			const data = rowData;
			try {
				const response = await requestDisableOffer(appData.appName, { ...data });
				if (response?.status !== 200 || !response?.data?.success) {
					showAlert(response.data.error || 'Error occured while disabling an offer', { type: 'error' });
					history.goBack();
					return;
				}
				showAlert('Offer Disabled');
			} catch (error: any) {
				showAlert(error?.response?.data?.error || 'Error occured while disabling an offer', { type: 'error' });
			}
		},
		[]
	);

	return {
		getTDSOfferData,
		requestUpdateOffer,
		requestCreateOffer,
		requestActivateOffer,
		toggleIsDisabledField,
		segmentLabelList,
		mapValueList
	};
};

export default useService;
